import React from 'react';
import { InputCardGroup } from '@components/cards/input-card-group';

import { EventChannelItem } from './components/event-channel-item';
import { EventChannelViewProps } from './event-channel-view.type';

export const EventChannelView = ({ channels, teams, handleChange, selectedChannelId }: EventChannelViewProps) => (
  <div className='flex flex-col gap-4 mt-6'>
    <InputCardGroup ariaLabel='Channels' className='px-4 sm:px-2'>
      {teams?.length
        ? teams.map((team) => (
            <div key={team.id} className='flex flex-col gap-4'>
              <p className='text-primary text-subtitle-l'>{team.name}</p>
              {team.channels.map((tChannel) => (
                <EventChannelItem
                  key={tChannel.id}
                  name={tChannel.name}
                  isChecked={tChannel.slug === selectedChannelId}
                  onSelect={() => handleChange(tChannel.slug)}
                />
              ))}
            </div>
          ))
        : channels?.map((channel) => (
            <EventChannelItem
              key={channel.id}
              name={channel.name}
              isChecked={channel.slug === selectedChannelId}
              onSelect={() => handleChange(channel.slug)}
            />
          ))}
    </InputCardGroup>
  </div>
);
